import NclayerAuthStrategy from "./strategies/NclayerAuthStrategy.js";
import DefaultAuthStrategy from "./strategies/DefaultAuthStrategy.js";

export default class AuthService {
  constructor(authPorts, storagePort, mode = "init") {
    this.authPorts = authPorts;
    this.storagePort = storagePort;
    this.mode = mode;
  }

  getStrategy(type, mode) {
    switch (type) {
      case "nclayer":
        return new NclayerAuthStrategy(
          this.authPorts.nclayer,
          this.storagePort,
          mode
        );
      case "login":
        return new DefaultAuthStrategy(
          this.authPorts.default,
          this.storagePort
        );
      default:
        throw new Error(`Неизвестный тип авторизации: ${type}`);
    }
  }

  async login(type, credentials = null) {
    const strategy = this.getStrategy(type, this.mode);
    return strategy.login(credentials);
  }

  async logout(type) {
    const strategy = this.getStrategy(type);
    return strategy.logout();
  }

  async refreshTokens(type) {
    const strategy = this.getStrategy(type);
    return strategy.refreshTokens();
  }
}
